// Reference: https://github.com/robinhoodmarkets/robinhood-trader-android/blob/2866f8f0868f9816b5977b2dd287cf6fe7c2db0e/trader/credit-card/feature-credit-card/src/main/java/com/robinhood/android/creditcard/ui/creditapplication/terms/TermsComposable.kt#L213
export const termsWebviewScript = `
  <script>            
    // Create viewport meta tag
    var meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'initial-scale=1.0, user-scalable=no';
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(meta);
    
    // Add custom CSS styling
    var cssString = \`
      :root {
        --fg: #D9D8D3;
        --fg3: #6E695E;
        --bg2: #1C1A17;
        --accent: #CFB97D;
      }
      body {
        color: var(--fg);
        background-color: var(--bg2);
        font-family: sans-serif;
        font-size: 12px;
        padding-left: 10px;
        padding-right: 10px
      }
      a {
        color: var(--accent);
        word-wrap: break-word;
      }
      td {
        padding: 8px 0;
        border-bottom: 1px solid var(--fg3);
      }
      tr:last-child td {
        border-bottom: 1px solid transparent;
      }
      pre {
        white-space: normal;
      }
      table {
        table-layout: fixed;
        width: 100%;
        border-collapse: collapse;
      }
      h3 {
        word-wrap: break-word;
      }
      tbody {
        vertical-align: top;
      }
    \`;
    
    var style = document.createElement('style');
    style.innerHTML = cssString;
    document.head.appendChild(style);
  </script>
`;
